module.exports = __webpack_public_path__ + "static/behir-3aca7c4c3e826be77612ac8ce8cfa382.jpg";